import { IconProps } from '@/types/global.types';

export default function MedicalPrescription({ className }: IconProps) {
    return (
        <svg
            className={`md:w-[300px] md:h-[300px] w-[250px] h-[250px] ${className}`}
            width="420"
            height="420"
            viewBox="0 0 420 420"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M374.918 122.045C374.918 122.045 307.382 24.815 223.062 14.525C148.63 5.38579 79.54 40.985 69.922 117.895C66.4948 145.321 60.3964 175.62 49.5604 200.619C37.4056 228.658 16.666 252.001 32.5504 305.904C48.4348 359.807 115.517 408.485 164.279 408.384C213.041 408.283 258.846 363.957 296.638 323.645C334.43 283.333 454.776 245.424 374.918 122.045Z"
                fill="#145DA0"
            />
            <path
                opacity="0.7"
                d="M374.918 122.045C374.918 122.045 307.382 24.815 223.062 14.525C148.63 5.38579 79.54 40.985 69.922 117.895C66.4948 145.321 60.3964 175.62 49.5604 200.619C37.4056 228.658 16.666 252.001 32.5504 305.904C48.4348 359.807 115.517 408.485 164.279 408.384C213.041 408.283 258.846 363.957 296.638 323.645C334.43 283.333 454.776 245.424 374.918 122.045Z"
                fill="white"
            />
            <g opacity="0.3">
                <path
                    d="M104.059 149.209H41L41.6384 137.037H104.697L104.059 149.209Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M104.059 166.253H41L41.6384 154.081H104.697L104.059 166.253Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M104.059 183.297H41L41.6384 171.125H104.697L104.059 183.297Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M104.059 200.341H41L41.6384 188.169H104.697L104.059 200.341Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M104.059 217.392H41L41.6384 205.212H104.697L104.059 217.392Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M104.059 234.436H41L41.6384 222.256H104.697L104.059 234.436Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M104.059 251.48H41L41.6384 239.3H104.697L104.059 251.48Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M104.059 268.522H41L41.6384 256.342H104.697L104.059 268.522Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M104.059 285.566H41L41.6384 273.386H104.697L104.059 285.566Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M104.059 302.61H41L41.6384 290.43H104.697L104.059 302.61Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M104.059 319.653H41L41.6384 307.481H104.697L104.059 319.653Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M170.735 149.209H107.676L108.314 137.037H171.373L170.735 149.209Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M170.735 166.253H107.676L108.314 154.081H171.373L170.735 166.253Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M170.735 183.297H107.676L108.314 171.125H171.373L170.735 183.297Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M170.735 200.341H107.676L108.314 188.169H171.373L170.735 200.341Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M170.735 217.392H107.676L108.314 205.212H171.373L170.735 217.392Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M170.735 234.436H107.676L108.314 222.256H171.373L170.735 234.436Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M170.735 251.48H107.676L108.314 239.3H171.373L170.735 251.48Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M170.735 268.522H107.676L108.314 256.342H171.373L170.735 268.522Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M170.735 285.566H107.676L108.314 273.386H171.373L170.735 285.566Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M170.735 302.61H107.676L108.314 290.43H171.373L170.735 302.61Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M170.735 319.653H107.676L108.314 307.481H171.373L170.735 319.653Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <g opacity="0.3">
                <path
                    d="M364.638 161.81H283.242V223.39H364.638V161.81Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M360.212 166.899H287.652V218.307H360.212V166.899Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M311.316 174.998H336.558"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M294.969 182.456H352.904"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M307.879 197.366H339.992"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M295.539 212.285H308.164"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M339.707 212.285H352.324"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <g opacity="0.3">
                <path
                    d="M386.737 236.376H326.828V281.702H386.737V236.376Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M383.489 240.122H330.082V277.964H383.489V240.122Z"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M347.5 246.085H366.072"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M335.465 251.571H378.112"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M344.965 262.551H368.611"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M335.887 273.529H345.177"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M368.391 273.529H377.681"
                    stroke="black"
                    strokeWidth="0.84"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <path
                d="M317.337 268.262L230.372 265.238C226.788 265.115 223.204 265.115 219.62 265.238L138.602 268.262L142.197 154.509C142.331 150.203 142.331 145.891 142.197 141.573L138.602 34.2383H317.337V268.262Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M320.208 30.2236H141.473V264.248H320.208V30.2236Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M308.319 94.0049H153.348V250.883H308.319V94.0049Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M154.805 70.5601V41.8741H163.205C164.665 41.8099 166.116 42.1407 167.405 42.8317C168.481 43.4718 169.317 44.4491 169.782 45.6121C170.321 47.0181 170.578 48.5167 170.538 50.0221C170.605 51.5824 170.276 53.1343 169.58 54.5329C168.993 55.6451 168.054 56.5314 166.909 57.0529C165.628 57.6013 164.245 57.8677 162.852 57.8341H160.021V70.5601H154.805ZM160.046 54.1297H162.029C162.79 54.1644 163.548 54.0236 164.246 53.7181C164.509 53.5865 164.741 53.4022 164.929 53.1767C165.117 52.9513 165.256 52.6894 165.338 52.4077C165.565 51.6191 165.667 50.8001 165.641 49.9801C165.658 49.1343 165.582 48.2892 165.414 47.4601C165.355 47.1657 165.237 46.8864 165.067 46.6394C164.896 46.3924 164.677 46.1828 164.423 46.0237C163.677 45.6675 162.853 45.5084 162.029 45.5617H160.046V54.1297Z"
                fill="#145DA0"
            />
            <path
                d="M161.18 84.3952L166.95 69.1744L161.356 55.7344H166.245L169.958 64.6216L173.217 55.7344H177.753L172.2 70.1656L178.148 84.3952H173.292L169.218 74.7604L165.674 84.3868L161.18 84.3952Z"
                fill="#145DA0"
            />
            <path
                d="M241.562 50.7197H307.813"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M241.562 65.0166H307.813"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M255.867 58.8252H307.813"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M255.867 71.6943H307.813"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M158.625 111.25H210.579"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M158.625 124.816H210.579"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M158.625 118.264H237.274"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M158.625 141.348H210.579"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M158.625 154.913H210.579"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M158.625 148.36H237.274"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M157.516 242.424H206.765"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M250.906 242.424H300.155"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M164.463 188.354C161.518 190.223 159.193 192.922 157.782 196.112C156.371 199.301 155.937 202.837 156.535 206.273C157.132 209.709 158.735 212.891 161.141 215.416C163.547 217.942 166.647 219.697 170.05 220.461C173.453 221.225 177.006 220.963 180.26 219.708C183.514 218.453 186.323 216.262 188.332 213.411C190.342 210.56 191.461 207.178 191.548 203.691C191.635 200.205 190.687 196.771 188.823 193.823C187.584 191.863 185.971 190.166 184.075 188.83C182.18 187.495 180.04 186.546 177.777 186.038C175.515 185.53 173.174 185.473 170.89 185.87C168.605 186.268 166.421 187.112 164.463 188.354ZM181.389 215.041C179.061 216.516 176.348 217.268 173.593 217.201C170.838 217.134 168.165 216.252 165.911 214.666C163.657 213.08 161.924 210.862 160.931 208.291C159.938 205.72 159.73 202.912 160.332 200.223C160.935 197.534 162.321 195.084 164.316 193.182C166.311 191.281 168.824 190.013 171.539 189.541C174.255 189.068 177.049 189.41 179.569 190.525C182.089 191.641 184.222 193.478 185.699 195.805C186.679 197.351 187.345 199.075 187.66 200.878C187.974 202.682 187.929 204.529 187.529 206.316C187.129 208.102 186.381 209.792 185.327 211.289C184.274 212.786 182.936 214.061 181.389 215.041Z"
                fill="#145DA0"
            />
            <path
                d="M180.474 197.526L165.453 207.044L166.986 209.464L182.007 199.945L180.474 197.526Z"
                fill="#145DA0"
            />
            <path
                d="M165.406 236.88C165.406 236.88 165.65 242.475 172.966 232.496C180.283 222.516 179.3 223.256 177.351 228.85C175.858 232.723 173.882 236.392 171.471 239.77C171.471 239.77 180.241 225.893 180.241 229.782C180.241 233.672 171.958 250.236 173.663 248.775C175.369 247.313 180.728 240.014 180.728 240.014C180.728 240.014 179.997 244.877 181.937 242.685C183.878 240.492 186.079 236.116 185.835 238.552C185.591 240.988 182.425 243.903 185.591 240.988C188.758 238.073 191.194 234.411 190.463 237.09C189.733 239.77 187.784 240.744 189.733 239.77C191.681 238.796 202.635 220.534 199.225 222.726C195.814 224.919 189.489 243.903 192.412 242.441C195.335 240.98 198.737 233.68 198.494 237.334C198.25 240.988 199.225 240.988 200.174 239.77"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M405.798 390.81H22.3047"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M405.798 398.84H22.3047"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M384.786 302.231H303.474C302.191 302.23 300.951 302.692 299.98 303.531C299.01 304.37 298.374 305.531 298.191 306.801L286.027 389.961H382.72L390.103 308.027C390.167 307.291 390.078 306.548 389.839 305.848C389.601 305.148 389.22 304.505 388.72 303.96C388.22 303.415 387.612 302.979 386.935 302.682C386.258 302.384 385.526 302.231 384.786 302.231Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M274.678 288.658C274.678 288.658 252.679 299.578 245.127 302.594C237.575 305.609 235.719 306.962 235.047 308.81C234.375 310.658 204.992 356.833 201.64 361.033C198.289 365.233 191.056 374.296 192.064 380.504C193.072 386.711 201.136 392.096 208.864 391.928C216.592 391.76 221.464 390.248 222.304 388.064C223.144 385.88 244.472 347.744 244.472 347.744L251.192 390.223H336.998C336.998 390.223 343.718 332.128 343.718 323.56C343.718 314.992 345.398 304.921 341.87 302.737C338.342 300.553 323.734 295.521 312.982 291.993C302.23 288.465 298.879 287.793 296.367 287.793C293.855 287.793 274.678 288.658 274.678 288.658Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M272.352 288.96C272.352 288.96 269.496 294.336 269.328 298.704C269.16 303.072 268.488 311.127 265.968 315.999C263.448 320.871 261.6 323.559 262.944 323.047C264.288 322.535 272.007 313.983 272.847 312.127C273.687 310.271 275.031 313.807 275.031 313.807C275.031 313.807 272.511 321.023 272.175 322.031C271.839 323.039 282.751 336.974 282.751 336.974C282.751 336.974 292.159 329.591 294.343 327.911C296.527 326.231 295.855 324.887 296.023 322.703C296.191 320.519 296.863 317.335 298.03 315.487C299.198 313.639 302.575 320.88 304.918 324.24C307.262 327.6 309.622 328.776 309.286 326.256C308.95 323.736 307.774 318.864 306.934 310.296C306.094 301.728 306.262 291.488 304.078 288.296C301.894 285.104 290.437 284.474 282.919 283.937C280.865 283.707 278.787 284.056 276.92 284.944C275.053 285.831 273.471 287.222 272.352 288.96Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M238.436 317.562L244.484 347.768L236.672 327.684"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M273.191 297.058C273.191 297.058 275.543 310.154 277.727 320.225C278.928 325.958 280.614 331.578 282.767 337.025C282.767 337.025 293.855 318.386 297.047 308.65C298.86 303.278 300.264 297.778 301.247 292.194H273.191V297.058Z"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M285.45 301.56L279.41 309.12L283.61 317.184L279.477 327.188C280.389 330.515 281.488 333.788 282.77 336.991C282.77 336.991 286.231 331.178 289.835 324.391L286.802 317.394L290.498 308.994L285.45 301.56Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M273.191 292.186V297.058C273.191 297.058 274.813 306.096 276.61 314.924L285.111 305.953L294.074 315.882C295.195 313.525 296.185 311.108 297.039 308.641C298.852 303.27 300.256 297.769 301.239 292.186H273.191Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M199.984 366.005C199.984 366.005 215.667 360.276 224.126 374.212"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M224.41 369.91C224.41 369.91 215.648 371.893 210.97 379.36C206.291 386.828 215.808 387.659 218.437 387.659C221.066 387.659 223.553 385.895 223.696 384.98C223.838 384.064 227.282 375.211 227.148 373.144C227.132 372.373 226.852 371.63 226.353 371.041C225.854 370.452 225.168 370.053 224.41 369.91Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M220.371 373.002C220.371 373.002 215.524 377.202 215.852 378.882C216.179 380.562 223.37 387.03 224.756 386.098C225.006 385.97 225.228 385.795 225.411 385.582C225.593 385.369 225.731 385.121 225.818 384.855C225.904 384.588 225.938 384.306 225.915 384.027C225.893 383.747 225.816 383.475 225.688 383.225C225.293 382.595 220.371 373.002 220.371 373.002Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M215.88 378.84C215.88 378.84 213.032 381.872 213.965 383.258C214.897 384.644 221.407 388.181 223.096 387.114C224.784 386.047 223.692 384.955 223.692 384.955L215.88 378.84Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M232.56 372.843L226.73 371.835L228.1 380.227L234.055 380.411L232.56 372.843Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M222.069 359.646L228.898 383.578L232.216 386.594V382.335L224.992 358.815C224.934 358.619 224.836 358.437 224.705 358.281C224.574 358.124 224.412 357.995 224.23 357.903C224.048 357.81 223.849 357.755 223.645 357.742C223.441 357.728 223.236 357.756 223.044 357.824C222.681 357.949 222.38 358.206 222.199 358.544C222.018 358.882 221.972 359.276 222.069 359.646Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M224.407 369.911C224.407 369.911 220.375 372.272 220.778 374.061C221.182 375.85 225.533 384.217 227.104 384.326C228.674 384.435 229.624 383.486 229.397 381.671C229.17 379.857 227.717 373.271 226.734 371.835C225.751 370.399 225.642 369.827 224.407 369.911Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M232.558 372.843C232.558 372.843 236.851 373.38 237.598 374.691C238.346 376.001 235.347 381.226 234.39 382.419C233.432 383.612 231.718 383.561 231.668 380.537C231.749 377.952 232.046 375.378 232.558 372.843Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M209.342 382.948H256.44C257.756 382.95 259.018 383.474 259.948 384.405C260.879 385.335 261.403 386.597 261.405 387.913C261.405 389.027 260.962 390.095 260.175 390.882C259.387 391.67 258.319 392.113 257.205 392.113H209.997C208.972 392.113 207.989 391.706 207.265 390.981C206.54 390.256 206.133 389.273 206.133 388.249V386.149C206.133 385.728 206.216 385.311 206.377 384.922C206.539 384.533 206.775 384.18 207.073 383.883C207.371 383.585 207.725 383.35 208.114 383.189C208.504 383.029 208.921 382.947 209.342 382.948Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M293.159 372.12C293.159 372.12 280.903 370.776 277.879 369.768C274.855 368.76 269.983 367.92 268.303 369.264C266.623 370.608 258.4 380.184 258.223 381.352C258.047 382.52 256.375 386.392 257.215 387.4C257.919 388.102 258.784 388.621 259.735 388.912C259.735 388.912 270.655 391.936 271.823 392.104C272.99 392.272 284.246 391.768 284.246 391.768L290.126 389.584L298.35 389.416C298.35 389.416 298.518 392.104 298.686 385.552C298.854 379 293.159 372.12 293.159 372.12Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M259.762 388.919C259.762 388.919 259.93 385.055 260.77 383.375C261.61 381.695 271.177 373.136 271.177 373.136"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M262.922 389.911C262.922 389.911 264.602 385.711 265.274 385.375C265.946 385.039 273.833 379.999 273.833 379.999"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M268.656 391.088C268.656 391.088 268.992 389.408 269.832 389.072C270.672 388.736 277.728 385.544 277.728 385.544"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M276.215 391.927L279.407 391.087L279.071 389.575L275.711 390.415"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M331.624 318.041C331.624 318.041 322.728 336.68 323.224 343.241C323.719 349.801 325.92 360.696 325.92 360.696C325.92 360.696 311.817 366.231 306.945 368.256C302.073 370.28 293.16 372.12 293.16 372.12L297.688 389.919L297.024 391.767H345.879C345.879 391.767 349.575 391.095 350.247 390.255C350.919 389.415 351.591 389.079 351.927 386.391C352.263 383.703 354.447 360.2 353.943 353.631C353.439 347.063 346.551 313.001 345.711 309.473C344.871 305.945 343.367 303.593 341.855 302.753C340.343 301.913 333.791 301.249 333.791 301.249"
                fill="white"
            />
            <path
                d="M331.624 318.041C331.624 318.041 322.728 336.68 323.224 343.241C323.719 349.801 325.92 360.696 325.92 360.696C325.92 360.696 311.817 366.231 306.945 368.256C302.073 370.28 293.16 372.12 293.16 372.12L297.688 389.919L297.024 391.767H345.879C345.879 391.767 349.575 391.095 350.247 390.255C350.919 389.415 351.591 389.079 351.927 386.391C352.263 383.703 354.447 360.2 353.943 353.631C353.439 347.063 346.551 313.001 345.711 309.473C344.871 305.945 343.367 303.593 341.855 302.753C340.343 301.913 333.791 301.249 333.791 301.249"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M327.094 361.031C327.094 361.031 340.021 361.703 346.414 365.727"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M329.438 359.352C329.438 359.352 338.51 358.848 343.382 360.36"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M326.927 317.52C326.927 317.52 322.391 328.104 322.223 332.136C322.055 336.168 321.719 338.52 321.719 338.52"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M306.273 289.498C306.273 289.498 316.513 304.08 308.281 344.745"
                stroke="#263238"
                strokeWidth="1.68"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M313.15 345.92C313.15 344.923 312.855 343.949 312.301 343.12C311.747 342.291 310.96 341.645 310.039 341.264C309.118 340.882 308.105 340.782 307.127 340.977C306.149 341.171 305.251 341.651 304.547 342.356C303.842 343.061 303.362 343.959 303.167 344.937C302.973 345.914 303.072 346.928 303.454 347.849C303.835 348.77 304.481 349.557 305.31 350.11C306.139 350.664 307.113 350.96 308.11 350.96C309.447 350.96 310.729 350.429 311.674 349.484C312.619 348.539 313.15 347.257 313.15 345.92Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M271.317 291.01C271.317 291.01 266.117 294.37 265.277 307.969"
                stroke="#263238"
                strokeWidth="1.68"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M272.502 328.574C271.234 337.747 269.503 347.6 269.142 349.759C268.302 354.379 262.817 355.992 259.289 354.48"
                stroke="#263238"
                strokeWidth="1.68"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M259.347 329.18C258.196 324.039 257.49 319.579 257.742 317.537C258.918 308.138 265.302 307.97 265.302 307.97C265.302 307.97 272.862 308.978 273.358 317.042C273.41 320.903 273.129 324.762 272.518 328.575"
                stroke="#263238"
                strokeWidth="1.68"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M273.531 353.808C273.531 353.808 270.003 355.824 267.651 354.48C266.063 353.573 261.771 339.898 259.352 329.18"
                stroke="#263238"
                strokeWidth="1.68"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M274.756 351.988L273.367 352.586C272.698 352.875 272.39 353.651 272.678 354.319L272.695 354.358C272.983 355.027 273.759 355.335 274.428 355.047L275.817 354.448C276.485 354.16 276.794 353.384 276.506 352.715L276.489 352.677C276.201 352.008 275.425 351.699 274.756 351.988Z"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M259.724 352.898L258.427 352.119C257.803 351.744 256.993 351.947 256.618 352.571L256.596 352.607C256.221 353.231 256.423 354.042 257.048 354.417L258.344 355.195C258.968 355.57 259.778 355.368 260.153 354.744L260.175 354.708C260.55 354.083 260.348 353.273 259.724 352.898Z"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M265.306 250.379C265.306 250.379 262.618 256.755 263.122 260.787C263.626 264.819 269.002 269.187 269.002 269.187C269.002 269.187 270.85 251.219 270.85 250.547C270.85 249.875 267.481 248.363 265.306 250.379Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M263.375 273.218L266.945 270.724"
                stroke="#263238"
                strokeWidth="1.68"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M267.309 251.555C267.309 251.555 266.637 269.355 266.973 272.706C267.309 276.058 268.653 286.81 269.829 290.17C271.005 293.53 274.869 304.274 277.893 305.45C280.917 306.626 286.957 307.466 288.973 306.122C290.989 304.778 298.372 299.746 300.388 294.874C301.583 292.033 302.375 289.039 302.74 285.978C304.417 285.084 305.864 283.816 306.971 282.271C308.079 280.727 308.815 278.949 309.124 277.074C310.132 270.69 307.444 268.851 307.444 268.851L307.612 257.763C307.612 257.763 305.764 250.043 300.892 245.843C296.02 241.643 290.317 241.307 284.437 244.499C278.557 247.691 267.309 251.555 267.309 251.555Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M298.881 250.547C298.881 250.547 299.049 246.179 294.858 247.691C290.666 249.203 289.65 252.059 283.434 254.579C277.218 257.099 268.994 254.243 266.147 252.563C263.299 250.883 261.275 248.531 265.139 244.163C269.003 239.795 278.066 235.436 287.819 235.436C297.571 235.436 305.114 243.491 308.306 246.851C311.498 250.211 312.002 254.411 310.826 257.427C309.65 260.442 307.466 268.851 307.466 268.851C307.466 268.851 306.122 268.683 305.618 270.69C305.114 272.698 305.282 274.89 303.098 275.058C300.914 275.226 301.082 269.355 301.082 269.355C301.082 269.355 295.715 267.675 295.043 263.811C294.371 259.947 298.881 254.243 298.881 250.547Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M278.879 275.957L263.348 273.219L264.246 280.182C264.302 280.615 264.495 281.019 264.798 281.334C265.1 281.648 265.496 281.857 265.926 281.93L275.368 283.416C275.887 283.5 276.418 283.379 276.85 283.078C277.281 282.777 277.578 282.32 277.678 281.804L278.879 275.957Z"
                stroke="#263238"
                strokeWidth="1.68"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M281.707 276.251L299.717 275.73L297.953 282.249C297.801 282.688 297.511 283.066 297.126 283.326C296.742 283.587 296.283 283.716 295.819 283.694L284.899 283.845C284.333 283.884 283.772 283.718 283.318 283.377C282.865 283.036 282.549 282.543 282.429 281.988L281.707 276.251Z"
                stroke="#263238"
                strokeWidth="1.68"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M278.902 275.957L281.708 276.251"
                stroke="#263238"
                strokeWidth="1.68"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M299.719 275.73L305.599 270.69"
                stroke="#263238"
                strokeWidth="1.68"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M284.105 274.219C284.105 274.219 289.145 270.363 293.849 272.707"
                stroke="#263238"
                strokeWidth="1.68"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M276.552 273.379C276.552 273.379 272.688 269.179 268.32 272.035"
                stroke="#263238"
                strokeWidth="1.68"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M277.561 287.985C277.561 287.985 276.721 291.513 277.561 292.185C278.991 292.975 280.641 293.27 282.256 293.025"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M275.039 294.84C275.039 294.84 278.399 297.36 281.591 297.528C284.783 297.696 288.471 295.344 288.471 295.344"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M287.465 277.746C287.465 277.746 289.481 280.098 292.841 277.578"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M270.922 276.712C270.922 276.712 272.602 279.316 276.264 277.275"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M166.739 250.53C166.739 250.53 167.806 266.532 167 267.867L164.639 271.866C164.639 271.866 165.706 283.34 163.573 284.667C161.919 285.553 160.106 286.098 158.239 286.272C158.239 286.272 156.105 294.806 155.299 295.873C154.492 296.94 149.696 300.409 148.1 300.913C146.504 301.417 141.43 301.753 129.427 294.512C117.423 287.271 112.887 284.911 113.156 280.913C113.425 276.914 113.996 272.378 113.996 272.378C113.996 272.378 115.331 253.167 117.734 247.304C120.136 241.441 150.544 238.232 157.214 239.837C163.883 241.441 166.739 250.53 166.739 250.53Z"
                fill="white"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M135.797 276.931L137.67 278.266C137.67 278.266 136.066 284.667 136.83 287.607"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M162.466 271.572C162.197 272.799 161.55 273.689 161.029 273.571C160.509 273.454 160.299 272.379 160.576 271.152C160.853 269.926 161.491 269.035 162.012 269.153C162.533 269.271 162.743 270.354 162.466 271.572Z"
                fill="#263238"
            />
            <path
                d="M159.746 266.674C159.746 266.674 162.652 263.768 165.08 266.515"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M156.069 248.396C156.069 248.396 159.529 254.797 159.269 256.132C159.009 257.468 148.063 260.668 148.063 260.668C148.063 260.668 146.997 267.069 145.392 267.867L143.796 268.665C142.517 266.927 141.443 265.047 140.596 263.062C138.731 259.064 136.06 258.022 133.128 261.995C130.197 265.969 132.591 275.335 134.195 276.133L135.791 276.931C135.791 276.931 134.455 278.266 129.39 279.073C124.325 279.879 120.587 280.937 116.857 279.871C113.128 278.804 107.785 268.665 105.937 255.595C104.089 242.524 109.936 231.327 117.697 227.875C125.459 224.422 143.04 227.606 144.367 228.404C145.695 229.202 154.775 224.943 160.109 227.606C165.443 230.269 165.149 233.209 166.51 235.073C167.871 236.938 174.775 234.544 175.313 241.214C175.851 247.883 173.179 251.882 169.71 252.411C166.241 252.94 156.069 248.396 156.069 248.396Z"
                fill="#263238"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M92.913 290.271C92.913 290.271 67.3518 303.904 62.4798 306.6C57.6078 309.297 56.877 311.716 56.5998 314.16C56.3226 316.605 56.5998 398.874 56.5998 398.874H194.671C194.671 398.874 173.729 336 173.041 328.978C172.352 321.956 170.857 309.498 168.908 308.037C166.959 306.575 139.441 294.404 139.441 294.404C139.441 294.404 132.863 287.348 117.29 287.348C101.716 287.348 92.913 290.271 92.913 290.271Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M108.742 340.359C109.465 340.645 110.195 340.905 110.926 341.149"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M81.4805 317.78C81.4805 317.78 91.5605 331.842 105.328 338.78"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M90.2344 334.085C90.2344 334.085 95.8288 339.688 107.513 342.855"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M159.602 313.908C155.713 318.327 150.236 325.391 148.422 331.893"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M163.752 309.498C163.752 309.498 162.979 310.246 161.77 311.531"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M149.872 324.105C149.872 324.105 146.218 331.161 145.496 335.546"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M91.4492 291.48C91.4492 291.48 105.57 290.993 118.959 291.237C132.349 291.48 141.118 295.621 141.118 295.621C141.118 295.621 133.08 285.886 129.434 283.694C125.788 281.501 114.583 277.813 105.334 280.77C99.6371 282.684 94.7474 286.456 91.4492 291.48Z"
                fill="#145DA0"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M51.2992 398.781L38.4304 349.439C38.3055 348.84 38.3158 348.221 38.4605 347.626C38.6052 347.031 38.8807 346.477 39.2669 346.002C39.6532 345.527 40.1404 345.144 40.6932 344.882C41.246 344.619 41.8504 344.483 42.4624 344.483H144.85C145.791 344.484 146.703 344.806 147.436 345.396C148.169 345.985 148.679 346.807 148.882 347.726L160.247 398.831"
                fill="#263238"
            />
            <path
                d="M51.2992 398.781L38.4304 349.439C38.3055 348.84 38.3158 348.221 38.4605 347.626C38.6052 347.031 38.8807 346.477 39.2669 346.002C39.6532 345.527 40.1404 345.144 40.6932 344.882C41.246 344.619 41.8504 344.483 42.4624 344.483H144.85C145.791 344.484 146.703 344.806 147.436 345.396C148.169 345.985 148.679 346.807 148.882 347.726L160.247 398.831"
                stroke="#263238"
                strokeWidth="0.84"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
